module.exports = __webpack_public_path__ + "static/media/1026016.126318be.jpg";